module.exports = __webpack_public_path__ + "static/media/logo.2a2cec7b.png";